import { SubjectDataForm, SubjectStopOptions } from '@mark43/cad-api';

export const MAXIMUM_DURATION = 1440;

export const SUBJECT_DATA_DEFAULT_OPTIONS: SubjectStopOptions = {
    userOptions: [],
    reasonForStopOptions: [],
    perceivedRaceOptions: [],
    genderOptions: [],
    perceivedOrKnownDisabilityOptions: [],
    resultOfStopOptions: [],
};

export const EMPTY_SUBJECT: SubjectDataForm = {
    id: undefined,
    reasonForStopOption: undefined,
    perceivedRaceOptions: [],
    genderOptions: [],
    isPerceivedLgbt: false,
    isEnglishFluent: false,
    perceivedAge: undefined,
    perceivedOrKnownDisabilityOptions: [],
    resultOfStopOptions: [],
};
